import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const courseDiscussionApi = createAsyncThunk(
    'auth/courseDiscussions',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.discussionAction("comments", 1), { params: data })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }

const courseDiscussionSlice = createSlice({
    name: 'courseDiscussion list',
    initialState: intialState,
    reducers: {
        resetCourseDiscussion: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(courseDiscussionApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(courseDiscussionApi.fulfilled, (state, action) => {
            state.loading = false
            let resArray = action?.payload?.results?.results || action?.payload?.result?.comments || action?.payload?.results || action?.payload?.result || [];
            if (!Array.isArray(resArray)) resArray = [];
            state.result = resArray;
            state.message = action?.payload?.message || action?.payload?.results?.message;
            state.total = action?.payload?.count || action?.payload?.results?.total_comments || action?.payload?.total || 0;
        })
        builder.addCase(courseDiscussionApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const { resetCourseDiscussion } = courseDiscussionSlice.actions
export const courseDiscussionReducer = courseDiscussionSlice.reducer
